import NetworkManager from './NetworkManager';

/**
 * Union of items on a store's LIVE published menus (all channels, deduped),
 * used by the menu-aware snooze picker. See the BFF live-menu.service for the
 * orchestration details.
 */

export interface LiveMenuItem {
  code: string;
  name: string;
  label: string;
}

export interface LiveMenuSummary {
  menuCode: string;
  name: string;
  channels: string[];
}

export interface LiveMenuItems {
  products: LiveMenuItem[];
  bundles: LiveMenuItem[];
  modifiers: LiveMenuItem[];
  optionValues: LiveMenuItem[];
  menus: LiveMenuSummary[];
  partial: boolean;
  failedMenus: string[];
  truncated: boolean;
  fetchedAt: string;
}

/**
 * Throws on failure (unlike the catalog search wrappers) — React Query needs
 * the rejection so the snooze picker falls back to catalog search.
 */
export const getLiveMenuItems = async (storeNumber: string): Promise<LiveMenuItems> => {
  const response = await NetworkManager.get<{ status: boolean; data: LiveMenuItems }>(
    `stores/${encodeURIComponent(storeNumber)}/live-menu-items`
  );
  if (!response?.status || !response.data) {
    throw new Error('Failed to load live menu items');
  }
  return response.data;
};
